import {match} from 'ts-pattern';

import type {DataGridRow} from '@dms/api/core';

import type {CustomerInsightsHistoryGroup} from '../types/CustomerInsightsViewModel';
import {CUSTOMER_INSIGHTS_GRID_FIELDS} from './customerInsightsGridFields';
import {getBusinessCaseRowType} from './getBusinessCaseRowType';
import {getCustomerInsightsBusinessCaseCategory} from './getCustomerInsightsBusinessCaseCategory';
import {mapDataGridRow} from './mapDataGridRow';
import {readDataGridCellKey} from './readDataGridCellKey';
import {CUSTOMER_INSIGHTS_HISTORY_LIMIT, takeNewestHistory} from './takeNewestHistory';

type BusinessCaseHistoryKind = 'sales' | 'purchases';

const isBusinessCaseInHistory = (row: DataGridRow, historyKind: BusinessCaseHistoryKind) =>
  match({
    state: readDataGridCellKey(row, CUSTOMER_INSIGHTS_GRID_FIELDS.businessCase.state),
    category: getCustomerInsightsBusinessCaseCategory(getBusinessCaseRowType(row)),
    historyKind,
  })
    .with({state: 'CLOSED', category: 'sale', historyKind: 'sales'}, () => true)
    .with({state: 'CLOSED', category: 'purchase', historyKind: 'purchases'}, () => true)
    .otherwise(() => false);

export function mapBusinessCaseHistory(
  rows: DataGridRow[],
  total: number | undefined,
  historyKind: BusinessCaseHistoryKind,
  limit = CUSTOMER_INSIGHTS_HISTORY_LIMIT
): CustomerInsightsHistoryGroup {
  const records = rows.flatMap((row) =>
    match(isBusinessCaseInHistory(row, historyKind))
      .with(true, () => [mapDataGridRow(row, 'businessCase')])
      .with(false, () => [])
      .exhaustive()
  );

  return takeNewestHistory(records, total, limit);
}
